import Api from "@/services/api/api/index.js"

const getList = () => {
  return Api.get("/department/list")
}

export default {
  getList
}
